import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/purchaseOrders`;

export const purchaseOrderService = {
  getAll,
  createPurchaseOrder,
  getById,
  updatePurchaseOrder,
  deletePurchaseOrder,
  search,
  getPurchaseOrderRecords,
};

function getAll(pageNumber) {
  return fetchWrapper.get(`${baseUrl}?pageNumber=${pageNumber}&pageSize=25`);
}

function getById(purchaseOrderId) {
  return fetchWrapper.get(`${baseUrl}/${purchaseOrderId}`);
}

function getPurchaseOrderRecords() {
  return fetchWrapper.get(`${baseUrl}/dashBord`);
}

function createPurchaseOrder(payload) {
  return fetchWrapper.post(baseUrl, payload);
}

function updatePurchaseOrder(payload, id) {
  return fetchWrapper.put(`${baseUrl}/${id}`, payload);
}

function deletePurchaseOrder(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}
